import React, { useEffect, useState } from "react";
import { Applogo, headerlogo, transplogo } from "../../../Routes/ImagePath";
import { Link, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as Yup from "yup";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const apiUrl = process.env.REACT_APP_API_URL;

const validationSchema = Yup.object().shape({
  newPassword: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[0-9]/, "Password must contain at least one number")
    .matches(/[@$!%*?&#]/, "Password must contain at least one special character")
    .required("New Password is required"),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), null], "Passwords must match")
    .required("Confirm Password is required"),
});

const ChangePassword = () => {
  const location = useLocation();
  const [isValidKey, setIsValidKey] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const { register, handleSubmit, formState: { errors }, control } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    const validateResetKey = async (key) => {
      try {
        const response = await fetch(`${apiUrl}/users/validate-reset-key`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ resetKey: key }),
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message);
        }

        setIsValidKey(true);
      } catch (error) {
        setIsValidKey(false);
        setErrorMessage(error.message);
        //toast.error(error.message);
      }
    };

    const queryParams = new URLSearchParams(location.search);
    const resetKey = queryParams.get('resetkey');

    if (resetKey) {
      validateResetKey(resetKey);
    } else {
      setIsValidKey(false);
      setErrorMessage('Invalid or missing reset key.');
      //toast.error('Invalid or missing reset key.');
    }
  }, [location]);

  const onSubmit = async (data) => {
    const queryParams = new URLSearchParams(location.search);
    const resetKey = queryParams.get('resetkey');

    try {
      const response = await fetch(`${apiUrl}/users/update-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          resetKey,
          newPassword: data.newPassword,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message);
      }

      setSuccessMessage('Password updated successfully. Please login with your new password.');
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <div className="change-password-container">
      <div className="change-password-top-header">
        <img src={transplogo} width={250} height={150} alt="NetShine Office" style={{ marginTop: "10px" }} />
      </div>
      <div className="change-password-form-container">
        <div className={`change-password-account-box ${!isValidKey && 'change-password-invalid-key'}`}>
          <div className="change-password-account-wrapper">
            <h3 className="change-password-account-title">Reset Password</h3>
            {isValidKey ? (
              successMessage ? (
                <div className="alert alert-success" role="alert">
                  {successMessage}
                  <p>
                    You can now <Link to="/login">Login</Link> with your new password.
                  </p>
                </div>
              ) : (
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="change-password-input-block mb-3">
                    <label className="col-form-label">New Password</label>
                    <Controller
                      name="newPassword"
                      control={control}
                      render={({ field }) => (
                        <input
                          type="password"
                          className={`form-control ${errors.newPassword ? "is-invalid" : ""}`}
                          {...field}
                        />
                      )}
                    />
                    <div className="change-password-invalid-feedback">{errors.newPassword?.message}</div>
                  </div>
                  <div className="change-password-input-block mb-3">
                    <label className="col-form-label">Confirm Password</label>
                    <Controller
                      name="confirmPassword"
                      control={control}
                      render={({ field }) => (
                        <input
                          type="password"
                          className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`}
                          {...field}
                        />
                      )}
                    />
                    <div className="change-password-invalid-feedback">{errors.confirmPassword?.message}</div>
                  </div>
                  <div className="change-password-submit-section mb-4">
                    <button type="submit" className="btn btn-primary change-password-submit-btn">
                      Update Password
                    </button>
                  </div>
                </form>
              )
            ) : (
              <div className="alert alert-danger" role="alert">
                {errorMessage}. Please check your link and try again.
                <p>
                  If you were redirected here by mistake, you can go back to the <Link to="/login">Login Page</Link>.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
